// Valeurs dynamiques de la LP (CLAUDE.md §6 et §8).
// RÈGLE LÉGALE : chaque chiffre affiché doit être vrai. Une valeur `null` => l'élément ne s'affiche pas
// (jauge, stock, compteur, compte à rebours) ou affiche un placeholder [À CONFIRMER] (textes).
// Mettre à jour aussi docs/A-CONFIRMER.md à chaque confirmation.

export const config = {
  dates: {
    preorderOpen: "2026-10-20",
    offerEnd: "2026-11-17T23:59:00+01:00",   // fin de l'offre de précommande : 17/11/2026 (validé le 06/10/2026)
    vipEnd: "2026-10-21T14:00:00+02:00",     // fin de l'ouverture VIP : 21/10/2026 à 14 h (décidé le 20/10/2026 ; avant : midi, puis 21/10 0 h)
    firstShipping: "2026-11-20"   // TODO confirmer (20/11 ou 05/12). Lot 13 (06/10/2026) : n'est plus affichée sur la page
  },

  // 52.1 : compte à rebours « Ouverture VIP » jusqu'à vipEnd, puis rien, puis « Fin de l'offre » les lastDays
  // derniers jours avant offerEnd. null => phase non affichée.
  countdown: { lastDays: 7 },

  pricing: {
    monthly: 12.90,               // prix mensuel sans engagement
    lampValue: 15                 // prix de la lampe sur le shop (prix barré autorisé)
  },

  // total = prix payé pour la formule. null => [À CONFIRMER] ; « soit / mois » et économie calculés dans le JS.
  // freeMonths sert au calcul indicatif tant que total est null.
  // planSku / planType / autoRenewal = formule présélectionnée dans le tunnel (js/funnel.js).
  // planSku null => gamme seule : le parent choisit sa formule sur /plan/.
  // url (facultatif) : lien direct qui remplace la présélection (si le tunnel accepte un jour un GET).
  // billing: "monthly" = affiché en paiement mensuel (« Soit x €/mois », sans « Payé en une fois »).
  // Prix : tableau des offres revu le 07/10/2026 (3 et 6 mois prépayés, 12 mois en paiement mensuel).
  // Codes : donnés par l'utilisateur le 19/10/2026 (3 mois SUBSCRIPTION-CREDITS-3POUR2, 6 et 12 mois -PROMO) ;
  // planType / reconduction relevés sur la page préprod www.pandacraft.ninja/abonnement-animalia-4-7-ans/.
  // TODO devs : code du 12 mois en paiement mensuel à remplacer ici quand il existe.
  plans: [
    { id: "3m",  months: 3,  label: "3 mois",  offer: "1 mois offert",   total: 25.80,  freeMonths: 1,
      planSku: "SUBSCRIPTION-CREDITS-3POUR2",   planType: "upfront", autoRenewal: "1", url: null },
    { id: "6m",  months: 6,  label: "6 mois",  offer: "2 mois offerts",  total: 51.60,  freeMonths: 2,
      planSku: "SUBSCRIPTION-CREDITS-6-PROMO",  planType: "upfront", autoRenewal: "",  url: null }, // sans reconduction sur le site
    // noteRef (55.2) : renvoi « * » vers la mention de l'offre en pied de page (id), qui vise la formule 12 mois
    { id: "12m", months: 12, label: "12 mois", offer: "3 mois offerts",  total: 109.90, freeMonths: 3, featured: true, billing: "monthly", noteRef: "note-offre",
      planSku: "SUBSCRIPTION-CREDITS-12-PROMO", planType: "commitment", autoRenewal: "1", url: null } // paiement mensuel (data-plan-type « commitment » sur www.pandacraft.com/abonnement/, 19/10)
  ],

  // Tunnel d'abonnement : il ignore les liens GET. Au clic, gamme + formule sont enregistrées en session
  // par un POST, puis le parent arrive sur /person/. La LP vise le tunnel de son propre environnement
  // (même domaine racine obligatoire : cookie de session). Autre hôte (localhost, aperçu) : rien n'est envoyé.
  funnel: {
    range: "animalia",            // TODO confirmer l'identifiant de gamme en prod
    productSku: "KTH-MAN-2612",   // kit présélectionné : l'étape du choix du kit est passée (code donné par l'utilisateur le 19/10/2026) ; null => le parent choisit
    hosts: {
      "shop.pandacraft.com": "https://www.pandacraft.com",
      "shop.pandacraft.ninja": "https://www.pandacraft.ninja"
    },
    timeoutMs: 3000               // sans réponse du POST : /person/ quand même
  },

  scarcity: {
    lampsTotal: 4000,             // stock réel de lampes de lancement (validé le 06/10/2026)
    // 52.1 (16/10/2026) : jauge des lampes retirée de la page (nav + offre) ; null => rien d'affiché.
    // Pour la remettre : nombre RÉEL de lampes réservées (jamais une valeur de test en prod, CLAUDE.md §6).
    lampsReserved: null,
    lampsReservedIsTest: false,
    showLimitedStock: true        // stock réellement limité à 4 000 lampes
  },

  // 53 : concours Wecasa (encart du mail du 16/10/2026) — tirage au sort parmi les précommandes.
  // active: false => carton et pastille masqués. rulesUrl null => « Règlement complet [À CONFIRMER] ».
  contest: {
    active: true,
    partner: "Wecasa",
    prizes: 10,                   // massages à domicile à gagner
    rulesUrl: "https://blog.pandacraft.com/wp-content/uploads/2026/10/Reglement-Jeu-concours-de-precommande-Mission-Animalia-6.pdf"   // règlement (version du 19/10/2026)
  },

  members: {
    count: null,                  // TODO nombre réel de précommandes
    minToDisplay: 300             // compteur masqué en dessous
  },

  trust: {
    rating: null,                 // TODO note moyenne réelle (ex. 4.8)
    reviewsCount: null,           // TODO nombre d'avis réel
    families: null                // TODO nombre de familles réel
  },

  // null = non confirmé => garantie non affichée
  guarantees: {
    refund: null,                 // TODO ex. "Satisfait ou remboursé 30 jours"
    cancelOneClick: null,         // TODO ex. "Résiliable en 1 clic" (conditionne « Sans engagement* »)
    freeShipping: "Livraison offerte"   // validé le 06/10/2026
  },

  // 58.1 (16/10/2026) : la FAQ est écrite dans partials/10-faq.html (textes validés, avec listes) ; plus de config.faq.


  media: {
    // 57.2 : extraits du module ② (fichiers du 16/10/2026, scripts/audio.sh). src : un fichier par format (.m4a si le navigateur le lit, sinon .mp3) ; chemins complets pour l'export Shopify.
    // vtt null => pas de sous-titres synchronisés : la bulle affiche `caption` (texte fixe, validé le 16/10/2026).
    tracks: [
      { id: "consigne", label: "une consigne", src: { m4a: new URL("ma-audio-consignes-extrait.m4a?v=9dbd173928", import.meta.url).href, mp3: new URL("ma-audio-consignes-extrait.mp3?v=9dbd173928", import.meta.url).href }, vtt: null,
        caption: "C'est l'alerte au Club Animalia ! Un animal est en danger…" },   // validé le 16/10/2026
      { id: "histoire", label: "une histoire", src: { m4a: new URL("ma-audio-boussole-histoire-extrait.m4a?v=9dbd173928", import.meta.url).href, mp3: new URL("ma-audio-boussole-histoire-extrait.mp3?v=9dbd173928", import.meta.url).href }, vtt: null,
        caption: "C'est l'alerte au Club Animalia ! Un animal est en danger…" }   // 57.3 : même bulle pour les deux extraits
    ]
  },

  // Pages légales de Pandacraft (relevées le 01/10/2026 dans le footer de www.pandacraft.com, toutes vérifiées)
  links: {
    legal: "https://www.pandacraft.com/mentions-legales/",
    cgv: "https://www.pandacraft.com/cgv/",
    contact: "https://aide.pandacraft.com/hc/fr/requests/new",   // « Contactez-nous » (formulaire du centre d'aide)
    privacy: "https://www.pandacraft.com/privacy/"               // « Protection des données » = politique de confidentialité
  },

  // IDs du site abonnement www.pandacraft.com (relevés le 01/10/2026) : la conversion a lieu dans son tunnel.
  // Tags chargés uniquement après consentement dans le bandeau Didomi de Pandacraft (js/consent.js).
  // hosts : tags chargés seulement sur ces hôtes (préprod et local : bandeau Didomi, aucun tag).
  tracking: {
    hosts: ["shop.pandacraft.com"],
    metaPixelId: "1063904080301660",
    ga4Id: "G-M2CSB6D7QN",
    // 11.15 (22/10/2026) : GA4 envoyé par le serveur de tracking du site (sGTM), comme le GTM de www.pandacraft.com
    // (transport_url + first_party_collection relevés dans GTM-TZ7KMZ) : sinon la session ouverte sur la LP n'est pas
    // celle de l'achat (sessions « (not set) » sur /person, ventes non rattachées à la LP). null => envoi direct à Google.
    ga4Server: "https://server-side-tagging-74zqmjvpca-uc.a.run.app",
    didomiKey: "69cd3642-a25c-461a-b9a4-6986c8909058",
    didomiVendors: { ga4: "c:googleana-4TXnJigR", meta: "c:facebooka-LMPqjfyA" }
  }
};
